import Moment from "moment"

const automaticpause = (state = [], action) => {
    switch (action.type) {
      case 'AUTOMATIC_PAUSE':
      let pauses = action.pauses.filter(pause => pause.tempo_restante > 5)
      pauses.map(pause => {
        let aux = Moment().format(pause.hora, 'HH:mm:ss')
        pause.hora_warning = Moment(aux, 'HH:mm:ss').subtract(pause.tm_warning_before,'seconds').format('HH:mm:ss')
      })
      return pauses
      default:
        return state
    }
  }
  
  export default automaticpause